export const INIT_EDIT_ORDER = 'order/INIT_EDIT_ORDER';

export const ORDER_UPDATE_REQUEST = 'order/ORDER_UPDATE_REQUEST';
export const ORDER_UPDATE_SUCCESS = 'order/ORDER_UPDATE_SUCCESS';
export const ORDER_UPDATE_ERROR = 'order/ORDER_UPDATE_ERROR';

export const ORDER_COPY_REQUEST = 'order/ORDER_COPY_REQUEST';
export const ORDER_COPY_SUCCESS = 'order/ORDER_COPY_SUCCESS';
export const ORDER_COPY_ERROR = 'order/ORDER_COPY_ERROR';

export const CREATE_SHIPMENT_FLOW = 'order/CREATE_SHIPMENT_FLOW';
export const CREATE_SHIPMENT_CLOSE = 'order/CREATE_SHIPMENT_CLOSE';
export const CREATE_SHIPMENT_SET_DATA = 'order/CREATE_SHIPMENT_SET_DATA';
export const CREATE_SHIPMENT_NEXT = 'order/CREATE_SHIPMENT_NEXT';
export const CREATE_SHIPMENT_BACK = 'order/CREATE_SHIPMENT_BACK';
export const CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_REQUEST =
  'order/CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_REQUEST';
export const CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_SUCCESS =
  'order/CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_SUCCESS';
export const CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_ERROR =
  'order/CREATE_SHIPMENT_PROCEED_TO_SEND_INVOICE_ERROR';
export const CREATE_SHIPMENT_SEND_INVOICE_REQUEST =
  'order/CREATE_SHIPMENT_SEND_INVOICE_REQUEST';
export const CREATE_SHIPMENT_SEND_INVOICE_SUCCESS =
  'order/CREATE_SHIPMENT_SEND_INVOICE_SUCCESS';
export const CREATE_SHIPMENT_SEND_INVOICE_ERROR =
  'order/CREATE_SHIPMENT_SEND_INVOICE_ERROR';
export const CREATE_SHIPMENT_REQUEST = 'order/CREATE_SHIPMENT_REQUEST';
export const CREATE_SHIPMENT_SUCCESS = 'order/CREATE_SHIPMENT_SUCCESS';
export const CREATE_SHIPMENT_ERROR = 'order/CREATE_SHIPMENT_ERROR';

export const DOWNLOAD_FILES_REQUEST = 'orders/DOWNLOAD_FILES_REQUEST';
export const DOWNLOAD_FILES_SUCCESS = 'orders/DOWNLOAD_FILES_SUCCESS';
export const DOWNLOAD_FILES_ERROR = 'orders/DOWNLOAD_FILES_ERROR';

export const CANCEL_ORDER_REQUEST = 'orders/CANCEL_ORDER_REQUEST';
export const CANCEL_ORDER_SUCCESS = 'orders/CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_ERROR = 'orders/CANCEL_ORDER_ERROR';

export const REFUND_NOTIFICATION_FLOW = 'orders/REFUND_NOTIFICATION_FLOW';
export const REFUND_NOTIFICATION_CLOSE = 'orders/REFUND_NOTIFICATION_CLOSE';
export const REFUND_NOTIFICATION_OPEN_MODAL =
  'orders/REFUND_NOTIFICATION_OPEN_MODAL';
export const REFUND_NOTIFICATION_REQUEST = 'orders/REFUND_NOTIFICATION_REQUEST';
export const REFUND_NOTIFICATION_SUCCESS = 'orders/REFUND_NOTIFICATION_SUCCESS';
export const REFUND_NOTIFICATION_ERROR = 'orders/REFUND_NOTIFICATION_ERROR';

export const UPDATE_PO_REQUEST = 'order/UPDATE_PO_REQUEST';
export const UPDATE_PO_SUCCESS = 'order/UPDATE_PO_SUCCESS';
export const UPDATE_PO_ERROR = 'order/UPDATE_PO_ERROR';

export const EXPORT_INVOICE_CSV_REQUEST = 'orders/EXPORT_INVOICE_CSV_REQUEST';
export const EXPORT_INVOICE_CSV_SUCCESS = 'orders/EXPORT_INVOICE_CSV_SUCCESS';
export const EXPORT_INVOICE_CSV_ERROR = 'orders/EXPORT_INVOICE_CSV_ERROR';
